// Sub Header Participant Tabs Navigation JavaScript

// Dropdown toggle function
function toggleDropdown() {
  const dropdown = document.getElementById("projectDropdown");
  if (dropdown) {
    dropdown.classList.toggle("open");
  }
}

// Close dropdown when clicking outside
window.addEventListener("click", function(e) {
  const dropdown = document.getElementById("projectDropdown");
  if (dropdown && !dropdown.contains(e.target)) {
    dropdown.classList.remove("open");
  }
});

// Mobile menu functions
function toggleMobileMenu() {
  const overlay = document.querySelector(".mobile-menu-overlay");
  const panel =
    document.querySelector(".mobile-menu-panel") ||
    document.querySelector("#mobileMenuPanel2");
  const toggle = document.querySelector(".mobile-menu-toggle");

  if (overlay && panel && toggle) {
    overlay.classList.toggle("active");
    panel.classList.toggle("active");
    toggle.classList.toggle("active");
    document.body.style.overflow = panel.classList.contains("active")
      ? "hidden"
      : "";
  }
}

function closeMobileMenu() {
  const overlay = document.querySelector(".mobile-menu-overlay");
  const panel =
    document.querySelector(".mobile-menu-panel") ||
    document.querySelector("#mobileMenuPanel2");
  const toggle = document.querySelector(".mobile-menu-toggle");

  if (overlay && panel && toggle) {
    overlay.classList.remove("active");
    panel.classList.remove("active");
    toggle.classList.remove("active");
    document.body.style.overflow = "";
  }
}

/**
 * HTML for lazy-tab loading state.
 * Mirrors resources/views/layouts/partials/loading-spinner.blade.php (mode=block).
 */
function getCmLoadingBlockHtml(message) {
  const label = message || "Loading…";
  return (
    '<div class="cm-card cm-card-spaced"><div class="cm-card-body">' +
    '<div class="cm-loading-block cm-empty-state" aria-busy="true" aria-live="polite">' +
    '<div class="la-ball-clip-rotate la-3x cm-loading-spinner" style="color: #87c4a3;">' +
    "<div></div>" +
    "</div>" +
    '<h4 class="no-record-text cm-loading-message">' +
    label +
    "</h4></div></div></div>"
  );
}

function toggleMobileDropdown(element) {
  const items = element.nextElementSibling;
  if (items) {
    items.classList.toggle("active");
    const icon = element.querySelector(".dropdown-icon");
    if (icon) {
      icon.textContent = items.classList.contains("active") ? "▲" : "▼";
    }
  }
}

// Initialize submenu link handlers for both detail pages and tab pages
document.addEventListener("DOMContentLoaded", function() {
  const submenuLinks = document.querySelectorAll(".submenu-link");
  const dropdownButton = document.querySelector(".dropdown-button");
  const projectHubLabel = 'PROJECT HUB <span class="dropdown-icon">▼</span>';

  submenuLinks.forEach(function(link) {
    link.addEventListener("click", function(e) {
      const href = this.getAttribute("href");

      // Check if this is a hash link (tab page) or full URL (detail page)
      const isHashLink = href && href.startsWith("#");

      // For detail pages (full URLs), allow normal navigation - don't prevent default
      // For tab pages (hash links), prevent default and handle tab switching
      if (isHashLink) {
        e.preventDefault();

        // Tab page behavior: show/hide content sections
        const targetId = href.replace("#", "");
        showParticipantTab(targetId);
      }
      // For detail pages (full URLs), the link will naturally navigate/reload
      // We still update the active state for visual feedback before navigation

      // Update active states
      submenuLinks.forEach(function(l) {
        l.classList.remove("active");
      });
      this.classList.add("active");

      // Update dropdown button label
      if (this.closest("#dropdownMenu")) {
        // Get the text and badge
        const linkText = this.cloneNode(true);
        const badge = linkText.querySelector(".badge");
        const textWithoutBadge = linkText.textContent
          .replace(badge?.textContent || "", "")
          .trim();
        const badgeHTML = badge ? badge.outerHTML : "";

        if (dropdownButton) {
          dropdownButton.innerHTML =
            textWithoutBadge +
            " " +
            badgeHTML +
            ' <span class="dropdown-icon">▼</span>';
          dropdownButton.classList.add("dropdown-active");
        }

        const projectDropdown = document.getElementById("projectDropdown");
        if (projectDropdown) {
          projectDropdown.classList.remove("open");
        }
      } else {
        if (dropdownButton) {
          dropdownButton.innerHTML = projectHubLabel;
          dropdownButton.classList.remove("dropdown-active");
        }
      }
    });
  });

  // On page load: check if any dropdown item is active and update label
  const activeDropdownItem = document.querySelector(
    "#dropdownMenu .submenu-link.active, #dropdownMenu a.active"
  );
  if (activeDropdownItem && dropdownButton) {
    const linkText = activeDropdownItem.cloneNode(true);
    const badge = linkText.querySelector(".badge");
    const textWithoutBadge = linkText.textContent
      .replace(badge?.textContent || "", "")
      .trim();
    const badgeHTML = badge ? badge.outerHTML : "";

    dropdownButton.innerHTML =
      textWithoutBadge +
      " " +
      badgeHTML +
      ' <span class="dropdown-icon">▼</span>';
    dropdownButton.classList.add("dropdown-active");
  }

  // Activate tab from URL parameter or hash (for tab pages)
  activateTabFromLocation();

  // Initial vue-app boot only — do not re-apply URL tab after lazy AJAX loads
  // (those dispatch coachmetrix:vue-app-ready again and would reset the highlight).
  var appliedLocationTabOnce = false;
  document.addEventListener("coachmetrix:vue-app-ready", function() {
    if (appliedLocationTabOnce) {
      return;
    }
    appliedLocationTabOnce = true;
    activateTabFromLocation();
  });
});

function syncParticipantTabInUrl(tabId) {
  if (!tabId) {
    return;
  }

  try {
    var url = new URL(window.location.href);
    url.searchParams.set("tab", tabId);
    // Keep Goals/Supporters sub-tab deep links. Clear other hashes so they
    // do not fight with ?tab= participant navigation.
    var preservedHash = url.hash === "#supporters" ? "#supporters" : "";
    url.hash = "";
    window.history.replaceState(
      {},
      "",
      url.pathname + "?" + url.searchParams.toString() + preservedHash
    );
  } catch (error) {
    // Ignore URL sync failures (older browsers / odd URLs).
  }
}

function setActiveParticipantTabLink(tabId) {
  if (!tabId) {
    return;
  }

  var links = document.querySelectorAll(
    ".submenu .submenu-link, .mobile-menu-content .submenu-link"
  );
  links.forEach(function(link) {
    link.classList.remove("active");
  });

  var matchSelector =
    '.submenu .submenu-link[href="#' +
    tabId +
    '"], .submenu .submenu-link[href*="tab=' +
    tabId +
    '"], .mobile-menu-content .submenu-link[href="#' +
    tabId +
    '"], .mobile-menu-content .submenu-link[href*="tab=' +
    tabId +
    '"]';

  document.querySelectorAll(matchSelector).forEach(function(link) {
    link.classList.add("active");
  });

  var dropdownButton = document.querySelector(".dropdown-button");
  var projectHubLabel = 'PROJECT HUB <span class="dropdown-icon">▼</span>';
  var activeDropdownItem = document.querySelector(
    "#dropdownMenu .submenu-link.active"
  );

  if (dropdownButton) {
    if (activeDropdownItem) {
      var linkText = activeDropdownItem.cloneNode(true);
      var badge = linkText.querySelector(".badge");
      var textWithoutBadge = linkText.textContent
        .replace(badge ? badge.textContent : "", "")
        .trim();
      var badgeHTML = badge ? badge.outerHTML : "";
      dropdownButton.innerHTML =
        textWithoutBadge +
        " " +
        badgeHTML +
        ' <span class="dropdown-icon">▼</span>';
      dropdownButton.classList.add("dropdown-active");
    } else {
      dropdownButton.innerHTML = projectHubLabel;
      dropdownButton.classList.remove("dropdown-active");
    }
  }
}

function relocateLazyTabModalNode(modal, origin) {
  if (!modal) {
    return;
  }

  if (origin) {
    modal.setAttribute("data-lazy-tab-origin", origin);
  }

  if (!modal.id) {
    document.body.appendChild(modal);
    return;
  }

  const existing = document.getElementById(modal.id);
  if (existing && existing !== modal) {
    existing.parentNode.removeChild(existing);
  }

  document.body.appendChild(modal);
}

function relocateLazyTabModals(root, origin) {
  if (!root || !root.querySelectorAll) {
    return;
  }

  Array.from(root.querySelectorAll(".modal")).forEach(function(modal) {
    relocateLazyTabModalNode(modal, origin);
  });
}

function cleanupLazyTabModals(origin) {
  if (!origin) {
    return;
  }

  document
    .querySelectorAll('.modal[data-lazy-tab-origin="' + origin + '"]')
    .forEach(function(modal) {
      if (modal.parentNode) {
        modal.parentNode.removeChild(modal);
      }
    });
}

/**
 * Call a Livewire SessionItem method from a Bootstrap modal.
 * Lazy-loaded tabs move modals to <body>, which breaks wire:click — look up
 * the mounted component by data-session-key instead.
 */
window.callLivewireSessionMethod = function(btn, method) {
  if (!btn || !method) {
    return;
  }

  const modal = btn.closest(".modal");
  if (!modal) {
    return;
  }

  const sessionKey = modal.getAttribute("data-session-key");
  if (!sessionKey) {
    return;
  }

  const items = document.querySelectorAll(
    '.session-item-list[data-session-key="' + sessionKey + '"]'
  );
  let item = null;

  items.forEach(function(el) {
    const tab = el.closest(".submenu-content");
    if (!tab || tab.style.display !== "none") {
      item = el;
    }
  });

  if (!item && items.length > 0) {
    item = items[0];
  }

  if (!item) {
    return;
  }

  const wireId = item.getAttribute("wire:id");
  if (!wireId) {
    return;
  }

  const livewire = window.Livewire || window.livewire;
  if (livewire && typeof livewire.find === "function") {
    livewire.find(wireId).call(method);
  }
};

window.showParticipantTab = function showParticipantTab(tabId) {
  const targetSection = document.getElementById(tabId);

  if (!targetSection || !targetSection.classList.contains("submenu-content")) {
    return;
  }

  // Keep URL + highlight in sync with the visible tab (including during AJAX load).
  syncParticipantTabInUrl(tabId);
  setActiveParticipantTabLink(tabId);

  const revealTab = function() {
    const section = document.getElementById(tabId);
    if (!section) {
      return;
    }

    document.querySelectorAll(".submenu-content").forEach(function(el) {
      el.style.display = "none";
    });
    section.style.display = "block";

    setActiveParticipantTabLink(tabId);

    try {
      window.scrollTo({ top: 0, behavior: "auto" });
    } catch (error) {
      window.scrollTo(0, 0);
    }

    refreshGoalsSupportersForTab(tabId);
    refreshParticipantSessionsForTab(tabId);
  };

  // Lazy-load heavy tabs on first open (keeps initial overview fast).
  // Tabs with data-refresh-on-show refetch every time they are opened (e.g. Events).
  const refreshOnShow = targetSection.dataset.refreshOnShow === "1";
  const needsFetch =
    targetSection.dataset.lazyTab &&
    (targetSection.dataset.lazyLoaded !== "1" || refreshOnShow);

  if (needsFetch) {
    // Already fetching — still reveal the tab so the loader stays visible
    // if the user left and came back before the request finished.
    if (targetSection.dataset.lazyLoading === "1") {
      revealTab();
      return;
    }

    const lazyTabKey = targetSection.dataset.lazyTab;
    const lazyTabUrl = targetSection.dataset.lazyUrl;
    const preserveRefreshOnShow = refreshOnShow;

    targetSection.dataset.lazyLoading = "1";

    // Always show the spinner while fetching. Required for refresh-on-show
    // tabs (Events) that replace prior content on every open.
    cleanupLazyTabModals(lazyTabKey);
    targetSection.innerHTML = getCmLoadingBlockHtml();

    let url = lazyTabUrl;

    // Forward page query params (e.g. round, chart_type) to the tab endpoint.
    try {
      const pageParams = new URLSearchParams(window.location.search);
      pageParams.delete("tab");
      const forwarded = pageParams.toString();
      if (forwarded) {
        url += (url.indexOf("?") >= 0 ? "&" : "?") + forwarded;
      }
    } catch (error) {
      // Keep base lazy URL if URLSearchParams fails.
    }

    // Show the tab shell (with Loading…) while fetching.
    revealTab();

    fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "text/html"
      }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Failed to load tab");
        }
        return response.text();
      })
      .then(function(html) {
        // Section may have been replaced if the user clicked away and back quickly.
        const currentSection = document.getElementById(tabId) || targetSection;

        const wrapper = document.createElement("div");
        wrapper.innerHTML = html.trim();

        const children = Array.from(wrapper.children);
        let newSection = null;
        const siblingNodes = [];

        children.forEach(function(child) {
          if (child.classList && child.classList.contains("submenu-content")) {
            newSection = child;
          } else {
            siblingNodes.push(child);
          }
        });

        if (!newSection) {
          newSection = wrapper.firstElementChild;
        }
        if (!newSection) {
          throw new Error("Empty tab response");
        }

        // innerHTML does not execute <script> tags — run them so Vue props initialize.
        const inlineScripts = [];
        wrapper.querySelectorAll("script").forEach(function(scriptEl) {
          if (!scriptEl.src) {
            inlineScripts.push(scriptEl.textContent);
          }
          scriptEl.parentNode.removeChild(scriptEl);
        });

        // Preserve lazy-load metadata across replace (AJAX partials omit these attrs).
        newSection.dataset.lazyTab = lazyTabKey;
        newSection.dataset.lazyUrl = lazyTabUrl;
        newSection.dataset.lazyLoaded = "1";
        newSection.dataset.lazyLoading = "0";
        if (preserveRefreshOnShow) {
          newSection.dataset.refreshOnShow = "1";
        }

        cleanupLazyTabModals(lazyTabKey);
        currentSection.replaceWith(newSection);

        // Move tab modals to <body> so Bootstrap can open them (not stuck in display:none parents).
        relocateLazyTabModals(newSection, lazyTabKey);
        siblingNodes.forEach(function(node) {
          if (node.classList && node.classList.contains("modal")) {
            relocateLazyTabModalNode(node, lazyTabKey);
          } else if (node.querySelectorAll) {
            relocateLazyTabModals(node, lazyTabKey);
            document.body.appendChild(node);
          }
        });

        // Reveal before inline scripts. AJAX partials ship with display:none;
        // C3 charts measure bindto width at generate-time and overflow their
        // card when initialized while hidden.
        revealTab();
        const visibleSection = document.getElementById(tabId) || newSection;
        if (visibleSection) {
          void visibleSection.offsetWidth;
        }

        inlineScripts.forEach(function(code) {
          try {
            const runnable = document.createElement("script");
            runnable.text = code;
            document.body.appendChild(runnable);
            document.body.removeChild(runnable);
          } catch (error) {
            console.error("Failed to run lazy tab script:", error);
          }
        });

        // Discussions (and other tabs) ship Trix editors via AJAX after
        // document-upload.js's initial pass — re-wire file attachment UI.
        if (typeof window.initTrixDocumentUploads === "function") {
          window.initTrixDocumentUploads(document.body);
        }

        if (window.Livewire && typeof window.Livewire.rescan === "function") {
          window.Livewire.rescan();
        } else if (
          window.livewire &&
          typeof window.livewire.rescan === "function"
        ) {
          window.livewire.rescan();
        }

        if (typeof window.mountGoalsSupportersApps === "function") {
          window.mountGoalsSupportersApps();
        }

        if (typeof window.mountCommunityApps === "function") {
          window.mountCommunityApps();
        }

        if (typeof window.mountAssignmentsListApp === "function") {
          window.mountAssignmentsListApp();
        }

        document.dispatchEvent(new CustomEvent("coachmetrix:vue-app-ready"));
      })
      .catch(function() {
        const section = document.getElementById(tabId) || targetSection;
        section.dataset.lazyLoading = "0";
        const body =
          section.querySelector(".cm-loading-message") ||
          section.querySelector(".cm-empty-state h4");
        if (body) {
          body.textContent = "Unable to load this tab. Please try again.";
        }
      });

    return;
  }

  revealTab();
};

function activateTabFromLocation() {
  const urlParams = new URLSearchParams(window.location.search);
  let tabId = urlParams.get("tab");

  if (!tabId && window.location.hash) {
    tabId = window.location.hash.replace("#", "");
  }

  if (!tabId) {
    return;
  }

  const targetSection = document.getElementById(tabId);

  if (!targetSection || !targetSection.classList.contains("submenu-content")) {
    return;
  }

  const targetLink = document.querySelector(
    '.submenu .submenu-link[href="#' +
      tabId +
      '"], .submenu .submenu-link[href*="' +
      tabId +
      '"]'
  );

  if (targetLink) {
    document.querySelectorAll(".submenu .submenu-link").forEach(function(link) {
      link.classList.remove("active");
    });
    targetLink.classList.add("active");
  }

  showParticipantTab(tabId);
}

function getGoalsSupportersContextForTab(tabId) {
  var contextByTab = {
    "overview-tab": "overview",
    "goals-tab": "detail"
  };

  return contextByTab[tabId] || null;
}

function isGoalsSupportersMounted(context) {
  var mountEl = document.getElementById("goals-supporters-" + context + "-app");

  return Boolean(mountEl && mountEl.__vue__);
}

function tryMountGoalsSupporters(context) {
  if (!context || isGoalsSupportersMounted(context)) {
    return true;
  }

  if (typeof window.mountGoalsSupportersApps === "function") {
    window.mountGoalsSupportersApps();
  }

  return isGoalsSupportersMounted(context);
}

function refreshGoalsDataForContext(context) {
  if (!context || !window.goalsSupportersVueInstances) {
    return;
  }

  var instance = window.goalsSupportersVueInstances[context];

  if (instance && typeof instance.loadData === "function") {
    instance.loadData({ silent: true });
  }
}

function applyPendingGoalsSupportersTab(context) {
  if (context !== "detail") {
    return;
  }

  var wantsSupporters =
    window.pendingGoalsSupportersTab === "supporters" ||
    window.location.hash === "#supporters";

  if (!wantsSupporters) {
    return;
  }

  if (typeof window.switchGoalsSupportersToSupporters === "function") {
    window.switchGoalsSupportersToSupporters();
    window.pendingGoalsSupportersTab = null;
  }
}

function refreshGoalsSupportersForTab(tabId) {
  if (!tabId) {
    return;
  }

  var context = getGoalsSupportersContextForTab(tabId);

  if (!context) {
    return;
  }

  if (!tryMountGoalsSupporters(context)) {
    var attempts = 0;
    var maxAttempts = 50;

    (function retryMount() {
      if (tryMountGoalsSupporters(context)) {
        refreshGoalsDataForContext(context);
        applyPendingGoalsSupportersTab(context);
        return;
      }

      if (attempts >= maxAttempts) {
        return;
      }

      attempts += 1;
      window.setTimeout(retryMount, 100);
    })();
    return;
  }

  refreshGoalsDataForContext(context);
  applyPendingGoalsSupportersTab(context);
}

/**
 * Refresh overview Livewire session lists when switching back to Overview
 * so edits made on the Events tab are reflected.
 */
function refreshParticipantSessionsForTab(tabId) {
  if (tabId !== "overview-tab") {
    return;
  }

  var livewire = window.Livewire || window.livewire;
  if (livewire && typeof livewire.emit === "function") {
    livewire.emit("refreshParticipantSessions");
  }
}

function clickTab(tabId) {
  const tab = document.getElementById(tabId);
  if (tab) {
    tab.click();
  } else {
    console.warn("Tab not found: " + tabId);
  }
}

// Set active state for mobile menu items based on URL parameter
// Only update if there's a tab parameter, otherwise preserve server-set active states
document.addEventListener("DOMContentLoaded", function() {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get("tab");

  // Function to update active state (only if tab parameter exists)
  function updateMobileMenuActiveState() {
    // Only update if there's a tab parameter in URL
    if (tabParam) {
      // Remove active from all mobile menu links
      document
        .querySelectorAll(".mobile-menu-content .submenu-link")
        .forEach(link => {
          link.classList.remove("active");
        });

      // Add active to the matching link
      const activeLink = document.querySelector(
        `.mobile-menu-content .submenu-link[href*="${tabParam}"]`
      );
      if (activeLink) {
        activeLink.classList.add("active");
      }
    }
    // If no tab param, preserve server-set active states (for detail pages)
  }

  updateMobileMenuActiveState();

  // Also update when mobile menu links are clicked
  document
    .querySelectorAll(".mobile-menu-content .submenu-link")
    .forEach(link => {
      link.addEventListener("click", function() {
        // Remove active from all
        document
          .querySelectorAll(".mobile-menu-content .submenu-link")
          .forEach(l => l.classList.remove("active"));
        // Add active to clicked link
        this.classList.add("active");
      });
    });
});
